var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgHero = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 1440,
  height: 594,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h1440v594H0z"
}), /*#__PURE__*/React.createElement("g", {
  filter: "url(#b)"
}, /*#__PURE__*/React.createElement("ellipse", {
  cx: 40.099,
  cy: 126.5,
  rx: 155.099,
  ry: 153.5,
  fill: "#0064FF"
})), /*#__PURE__*/React.createElement("g", {
  filter: "url(#c)"
}, /*#__PURE__*/React.createElement("ellipse", {
  cx: 0.099,
  cy: 126.5,
  rx: 155.099,
  ry: 153.5,
  fill: "#0064FF"
})), /*#__PURE__*/React.createElement("g", {
  filter: "url(#d)"
}, /*#__PURE__*/React.createElement("ellipse", {
  cx: 1361.5,
  cy: -19,
  rx: 135.5,
  ry: 134,
  fill: "#FF7A00"
})), /*#__PURE__*/React.createElement("g", {
  filter: "url(#e)"
}, /*#__PURE__*/React.createElement("ellipse", {
  cx: 1361.5,
  cy: -19,
  rx: 135.5,
  ry: 134,
  fill: "#FF7A00"
})), /*#__PURE__*/React.createElement("g", {
  filter: "url(#f)"
}, /*#__PURE__*/React.createElement("ellipse", {
  cx: 720.099,
  cy: 642.5,
  rx: 155.099,
  ry: 153.5,
  fill: "#61FFE3"
})))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "b",
  x: -815,
  y: -727,
  width: 1710.2,
  height: 1707,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 350,
  result: "effect1_foregroundBlur_5260_26176"
})), /*#__PURE__*/React.createElement("filter", {
  id: "c",
  x: -855,
  y: -727,
  width: 1710.2,
  height: 1707,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 350,
  result: "effect1_foregroundBlur_5260_26176"
})), /*#__PURE__*/React.createElement("filter", {
  id: "d",
  x: 626,
  y: -753,
  width: 1471,
  height: 1468,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 300,
  result: "effect1_foregroundBlur_5260_26176"
})), /*#__PURE__*/React.createElement("filter", {
  id: "e",
  x: 626,
  y: -753,
  width: 1471,
  height: 1468,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 300,
  result: "effect1_foregroundBlur_5260_26176"
})), /*#__PURE__*/React.createElement("filter", {
  id: "f",
  x: -135,
  y: -211,
  width: 1710.2,
  height: 1707,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 350,
  result: "effect1_foregroundBlur_5260_26176"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h1440v594H0z"
})))));
export default SvgHero;